import { render } from "./ResetConfirmModal.vue?vue&type=template&id=2d3cbb28&scoped=true"
import script from "./ResetConfirmModal.vue?vue&type=script&lang=js"
export * from "./ResetConfirmModal.vue?vue&type=script&lang=js"

import "./ResetConfirmModal.vue?vue&type=style&index=0&id=2d3cbb28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3cbb28"]])

export default __exports__